import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseService} from '@ui-kit/framework/common/base.service';
import {Observable} from 'rxjs';
import {AccountSoftwareSettings, ExternalAccountSoftware} from '@features/settings/details/settings-details.model';
import {environment} from '@env/environment';
import {ConsoleContextService} from '@security/console-context.service';
import {UtilsService} from '@shared-services/utils.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsDetailsService extends BaseService {
  baseUrl = environment.apiDistrictsHost;

  constructor(private http: HttpClient, private context: ConsoleContextService, private utilsService: UtilsService) {
    super();
  }

  getExternalAccountingSoftwareSettings(): Observable<ExternalAccountSoftware[]> {
    const offeringUuid = this.context.getCurrentOfferingId();
    return this.http.get<ExternalAccountSoftware[]>(`${this.baseUrl}/console/districts/${offeringUuid}/external-software/settings`);
  }

  updateConfig(code: string, config: AccountSoftwareSettings): Observable<ExternalAccountSoftware> {
    const offeringUuid = this.context.getCurrentOfferingId();
    return this.http.post<ExternalAccountSoftware>(`${this.baseUrl}/console/districts/${offeringUuid}/external-software/settings/${code}`, config);
  }
}
